import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import SubmittingDialog from "../../Components/Loading/SubmittingDialog";

// Libraries
import { Form, InputGroup } from "react-bootstrap";





export default function CreateProduct() {
    const params = useParams();
    const { dispatch, user } = useAuthContext();
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const [form, setForm] = useState({
        name: "",
        code: "",
        supplierId: 0,
        costPriceSummer: 0,
        salePriceSummer: 0,
        haulageRateSummer: 0,
        costPriceWinter: 0,
        salePriceWinter: 0,
        haulageRateWinter: 0,
        type: ""
    });
    const [isValid, setIsValid] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [suppliers, setSuppliers] = useState([]);

    


    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value,
        });
    };

    useEffect(() => {
        // Load the list of suppliers
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/suppliers/`, { headers: { Authorization: `bearer ${user.token}` } })
            .then((res) => {
                
                if (res.status === 200) {
                    console.log("response:", res.data);
                    setSuppliers(res.data);
                }
            }).catch((err) => {
                if (err.response.status === 401) {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                }
            })

        // Load the product details
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/products/${params.id}`, {
                headers: { Authorization: `bearer ${user.token}` },
            })
            .then((res) => {
                console.log("Product:", res.data);
                setForm(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);

                if (err.response.status === 401) {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                }
            });


    }, [])

    useEffect(() => {
        
        if (isValid) {
            console.log("submitting...", isValid)
            setSubmitting(true);
            axios
                .put(`https://${process.env.REACT_APP_IP}/api/products/${params.id}`, form, { headers: { Authorization: `bearer ${user.token}` } })
                .then((res) => {
                    console.log("response:", res);
                    setSubmitting(false);

                    if (res.status === 200) {
                        navigate(`/Products/View/${res.data.id}`)
                    }
                })
                .catch((err) => {
                    console.log(err.response.data);
                    setSubmitting(false);



                    if (err.code === "ERR_NETWORK") {
                        setFormErrors({ general: "Connection to the server could not be established. Please try again in a few minutes" });
                    }
                    else if (err.code === "ERR_BAD_REQUEST") {
                        setFormErrors(err.response.data.errors);
                    }
                    else if (err.response.status === 401) {
                        dispatch({ type: "LOGOUT" })
                        navigate("../")
                    }
                    else {
                        setFormErrors({ general: "An unknown error occured. " + err.code });
                    }
                });
        }
    }, [isValid]);

    useEffect(() => {
        console.log("forMErrors changed")
        setIsValid(formErrors.name === "")
    }, [formErrors])

    const handleSubmit = (event) => {
        console.log("handle submit", form)
        event.preventDefault();

        setFormErrors({
            name: form.name === undefined || form.name === "" ? "Product name is required" : "",
            supplierId: form.supplierId === undefined || form.supplierId === 0 ? "Supplier is required" : "",
            type: form.type === undefined || form.type === "" ? "Product Type is required" : "",
        });
    }

    return (
        <div className="page">

            {submitting && (
                <SubmittingDialog />
            )}

            <div className="row">
                <div className="col-12">
                    <h1>
                      Create Product
                    </h1>
                </div>
            </div>

            <Form onSubmit={handleSubmit} noValidate >

            
            <div className="row">
                {/* Contact Details */}
                <div className="col-md-6">
                    <h3>Product Details</h3>

                   
                    <div className="row">
                        <div className="col-md-12">
                            { /* Code */}
                            <div className="form-group col-4">
                                <label>Code</label>
                                <Form.Control
                                    required
                                    type="text"
                                    placeholder="e.g A1001"
                                    isInvalid={formErrors && formErrors.code}
                                    onChange={(e) => setField("code", e.target.value)}
                                    value={form && form.code}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.code}
                                </Form.Control.Feedback>
                            </div>


                            { /* Product Name */}
                            <div className="form-group">
                                <label>Product Name</label>
                                <Form.Control
                                    required
                                    type="text"
                                    placeholder="e.g Cattle Feed (10kg Bag)"
                                    isInvalid={formErrors && formErrors.name}
                                    onChange={(e) => setField("name", e.target.value)}
                                    value={form && form.name}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.name}
                                </Form.Control.Feedback>
                            </div>

                            { /* Product Type */}
                            <div className="form-group">
                                <label>Product Type</label>
                                <div className="select">
                                    <Form.Select 
                                        onChange={(e) => setField("type", e.target.value)}
                                        isInvalid={formErrors && formErrors.type}
                                        value={form && form.type}
                                    >
                                        <option value="" disabled>Please Select...</option>
                                        <option>Additives</option>
                                        <option>Blend</option>
                                        <option>Buffers</option>
                                        <option>Caustic Wheat</option>
                                        <option>Compound</option>
                                        <option>Fat</option>
                                        <option>Grass Seeds</option>
                                        <option>Milk Powder</option>
                                        <option>Minerals</option>
                                        <option>Moist Feed</option>
                                        <option>Molases</option>
                                        <option>Yeast</option>
                                    </Form.Select>
                                    <Form.Control.Feedback className="text-danger" type="invalid">
                                        {formErrors.type}
                                    </Form.Control.Feedback>
                                </div>
                            </div>

                            { /* Supplier */}
                            <div className="form-group">
                                <label>Supplier</label>
                                <div className="select">
                                        <Form.Select
                                            onChange={(e) => setField("supplierId", e.target.value)}
                                            isInvalid={formErrors && formErrors.supplierId}
                                            value={form && form.supplierId}
                                        >
                                        <option value="0" disabled>Please Select...</option>
                                        {suppliers && (suppliers.map((supplier) => {
                                            return <option key={supplier.id} value={supplier.id}>{supplier.name}</option>
                                        }))}
                                    </Form.Select>
                                    <Form.Control.Feedback className="text-danger" type="invalid">
                                        {formErrors.supplierId}
                                    </Form.Control.Feedback>
                                </div>
                            </div>

                            

                        </div>
                        
                    </div>

                   
                    

                    

                   

                    

                        
                    
                </div>

                {/* Pricing Details */}
                <div className="col-md-6">
                        <h3>Pricing Details</h3>

                        <div className="row">
                            <div className="col-6">

                                { /* Cost Price */}
                                <div className="form-group col-12">
                                    <label>Cost Price Summer</label>
                                    <InputGroup>
                                        <InputGroup.Text>&#163;</InputGroup.Text> {/* Prefix */}
                                        <Form.Control
                                            required
                                            type="text"
                                            placeholder="e.g 79.99"
                                            isInvalid={formErrors && formErrors.costPriceSummer}
                                            onChange={(e) => setField("costPriceSummer", e.target.value)}
                                            value={form && form.costPriceSummer}
                                        />
                                    </InputGroup>
                                    <Form.Control.Feedback className="text-danger" type="invalid">
                                        {formErrors.costPriceSummer}
                                    </Form.Control.Feedback>
                                </div>

                                { /* Sale Price */}
                                <div className="form-group col-12">
                                    <label>Sale Price Summer</label>
                                    <InputGroup>
                                        <InputGroup.Text>&#163;</InputGroup.Text> {/* Prefix */}
                                        <Form.Control
                                            required
                                            type="text"
                                            placeholder="e.g 79.99"
                                            isInvalid={formErrors && formErrors.salePriceSummer}
                                            onChange={(e) => setField("salePriceSummer", e.target.value)}
                                            value={form && form.salePriceSummer}
                                        />
                                    </InputGroup>
                                    <Form.Control.Feedback className="text-danger" type="invalid">
                                        {formErrors.salePriceSummer}
                                    </Form.Control.Feedback>
                                </div>

                                { /* Haulage Rate */}
                                <div className="form-group col-12">
                                    <label>Haulage Rate Summer</label>
                                    <InputGroup>
                                        <InputGroup.Text>&#163;</InputGroup.Text> {/* Prefix */}
                                        <Form.Control
                                            required
                                            type="text"
                                            placeholder="e.g 79.99"
                                            isInvalid={formErrors && formErrors.haulageRateSummer}
                                            onChange={(e) => setField("haulageRateSummer", e.target.value)}
                                            value={form && form.haulageRateSummer}
                                        />
                                    </InputGroup>
                                    <Form.Control.Feedback className="text-danger" type="invalid">
                                        {formErrors.haulageRateSummer}
                                    </Form.Control.Feedback>
                                </div>
                            </div>
                            <div className="col-6">
                                { /* Cost Price */}
                                <div className="form-group col-12">
                                    <label>Cost Price Winter</label>
                                    <InputGroup>
                                        <InputGroup.Text>&#163;</InputGroup.Text> {/* Prefix */}
                                        <Form.Control
                                            required
                                            type="text"
                                            placeholder="e.g 79.99"
                                            isInvalid={formErrors && formErrors.costPriceWinter}
                                            onChange={(e) => setField("costPriceWinter", e.target.value)}
                                            value={form && form.costPriceWinter}
                                        />
                                    </InputGroup>
                                    <Form.Control.Feedback className="text-danger" type="invalid">
                                        {formErrors.costPriceWinter}
                                    </Form.Control.Feedback>
                                </div>

                                { /* Sale Price */}
                                <div className="form-group col-12">
                                    <label>Sale Price Winter</label>
                                    <InputGroup>
                                        <InputGroup.Text>&#163;</InputGroup.Text> {/* Prefix */}
                                        <Form.Control
                                            required
                                            type="text"
                                            placeholder="e.g 79.99"
                                            isInvalid={formErrors && formErrors.salePriceWinter}
                                            onChange={(e) => setField("salePriceWinter", e.target.value)}
                                            value={form && form.salePriceWinter}
                                        />
                                    </InputGroup>
                                    <Form.Control.Feedback className="text-danger" type="invalid">
                                        {formErrors.salePriceWinter}
                                    </Form.Control.Feedback>
                                </div>

                                { /* Haulage Rate */}
                                <div className="form-group col-12">
                                    <label>Haulage Rate Winter</label>
                                    <InputGroup>
                                        <InputGroup.Text>&#163;</InputGroup.Text> {/* Prefix */}
                                        <Form.Control
                                            required
                                            type="text"
                                            placeholder="e.g 79.99"
                                            isInvalid={formErrors && formErrors.haulageRateWinter}
                                            onChange={(e) => setField("haulageRateWinter", e.target.value)}
                                            value={form && form.haulageRateWinter}
                                        />
                                    </InputGroup>
                                    <Form.Control.Feedback className="text-danger" type="invalid">
                                        {formErrors.haulageRateWinter}
                                    </Form.Control.Feedback>
                                </div>
                            </div>
                        </div>

                    
                </div>
            </div>
            


            <hr />

            {formErrors.general && (
                <div className="row">
                    <div className="col-md-12">
                        <div className="alert alert-danger">
                            {formErrors.general}
                        </div>
                    </div>
                </div>
            )}

            <div className="row">
                <div className="col-md-12">
                    <button className="btn btn-primary">Update Product</button>
                    <button className="btn btn-other" style={{ marginLeft: 10 }} onClick={() => { navigate(`/Products/`) }}>Cancel</button>
                </div>
            </div>
            </Form>

        </div>
  )
}
